import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { UserSessionData } from '@cencosud-cencommerce/paris-login';
import { createLocalStorage } from '@cencosud-cencommerce/paris-login';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { URL_ROUTES } from '@/constants';
import {
  getWeddingID,
  isWeddingFlow
} from '@/modules/shared/utils/isWeddingFlow';

const useHandleLogin = () => {
  const navigate = useNavigate();
  const userSessionData = createLocalStorage<UserSessionData>('sessionData');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const userData = userSessionData.get();
      if (!userData) {
        throw new Error(
          'El usuario no está logueado o no ha creado una cuenta'
        );
      } else {
        localStorage.removeItem('guestSessionData');

        const isWedding = isWeddingFlow();
        if (isWedding) {
          const weddingId = getWeddingID();
          const billingPath = URL_ROUTES.WEDDING_BILLING_PATH;
          const url = billingPath?.replace(':weddingId', weddingId);
          return navigate(url);
        }

        navigate(URL_ROUTES.SHIPPING);
      }
    } catch (error) {
      toast({
        status: 'error',
        title: 'Error al procesar el inicio de sesión o el carrito'
      });
    }
  };

  return { handleLogin, isLoading };
};

export default useHandleLogin;
